import {
  timepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPost,
  TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostResponse,
  TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostData,
  HTTPValidationError,
} from '@common/config/api/client'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { queryClient } from '@common/config/api/queryClient.ts'
import { queryKeyFactory } from '@features/study_details/Subjects/queryKeyFactory'
import { toast } from 'sonner'
import Toast from '@common/components/Toast'
import { handleMutationError } from '@common/hooks/handleMutationError'

export const useSignPayload = () => {
  return useMutation<
    TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostResponse,
    AxiosError<HTTPValidationError>,
    TimepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPostData
  >({
    mutationFn: async (query) => {
      const response =
        await timepointSubmissionEsignStudiesStudyIdSubjectsSubjectIdTimepointSubmissionTimepointSubmissionIdEsignPost({
          body: query.body,
          path: query.path,
          throwOnError: true,
        })
      return response.data
    },
    onSuccess: (_, query) => {
      void queryClient.invalidateQueries({ queryKey: ['TimePointsDetails', query.path.timepoint_submission_id] })
      void queryClient.invalidateQueries({ queryKey: ['SubjectsList'] })
      void queryClient.invalidateQueries({
        queryKey: queryKeyFactory.subjectTimepoints({
          study_id: query.path.study_id,
          subject_id: query.path.subject_id,
        }),
      })

      toast(<Toast message="Visit has been successfully submitted" variant="success" />)
    },
    onError: (error) => {
      handleMutationError(error)
    },
  })
}
